export const HTTP_GET_METHOD = 'GET';
export const HTTP_POST_METHOD = 'POST';
export const HTTP_PATCH_METHOD = 'PATCH';
export const HTTP_PUT_METHOD = 'PUT';
export const HTTP_DELETE_METHOD = 'DELETE';
